export default {
  valueType: 'select',
  FormItemProps: {
    label: '下拉框',
    rules: [],
    style: {}
  },
  ControlFieldNames: {
    valueName: "value",
    labelName: "label",
  },
  options: [],
  ControlProps: {
    allowClear: true,
    placeholder: "请选择",
    mode: "",
    style: {}
  },
  request: {
    url: "",
    type: "get",
    getData: ["data", "data"]
  },
}
